import { IconColor } from './iconsInterface'

export default function PlayIcon({ color }: IconColor): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200">
      <path
        d="M1024.26 175.74C969.17 120.65 905 77.39 833.56 47.17 759.57 15.87 680.98 0 600 0S440.43 15.87 366.43 47.16c-71.44 30.21-135.62 73.48-190.7 128.57S77.38 294.99 47.16 366.43C15.87 440.43 0 519.02 0 600s15.87 159.57 47.16 233.57c30.21 71.44 73.48 135.62 128.57 190.7s119.26 98.35 190.7 128.57c74 31.3 152.58 47.16 233.57 47.16s159.57-15.87 233.57-47.16c71.44-30.21 135.62-73.48 190.7-128.57s98.35-119.26 128.57-190.7c31.3-74 47.16-152.58 47.16-233.57s-15.87-159.57-47.16-233.57c-30.21-71.44-73.48-135.62-128.57-190.7h0zM845.71 624.77L498.85 833.11c-4.63 2.79-9.74 4.17-14.87 4.17s-9.74-1.26-14.22-3.8c-9.18-5.18-14.65-14.58-14.65-25.12V391.64c0-10.54 5.47-19.94 14.65-25.12 9.17-5.2 20.05-5.05 29.09.38l346.86 208.36c8.78 5.25 14 14.51 14 24.74s-5.23 19.49-14 24.76h0z"
        fill={color}
      />
    </svg>
  )
}
